<template>
  <div>
    <ol class="number-list">
      <div class>
        2020/03/23 팝업 테스트용 페이지 인것 같습니다.
        <br />
      </div>
      <li>
        <vs-button @click="popupRestrict=true" color="primary" vs-type="filled">서비스 이용제한 안내</vs-button>
        <!-- POPUP 서비스 이용제한 안내//S -->
        <vs-popup title="서비스 이용제한 안내" :active.sync="popupRestrict">
          <p class="text-center">
            미성년자(만 19세 미만) 또는 외국인 회원은 입/출금및
            거래 서비스를 포함한 FLYBIT에서 제공하는
            주요 서비스의 이용이 제한됩니다.
          </p>
          <vs-button
            color="primary"
            @click.prevent="popupRestrict = false"
            class="btn-block custom"
            type="filled"
          >확인</vs-button>
        </vs-popup>
        <!-- POPUP 서비스 이용제한 안내//E -->
      </li>
      <li>
        <vs-button @click="popupMailingComp=true" color="primary" vs-type="filled">인증메일 발송완료</vs-button>
        <!-- POPUP 인증메일 발송완료//S -->
        <vs-popup title="인증메일 발송완료" :active.sync="popupMailingComp">
          <p class="text-center">
            회원님의 계정으로 인증 이메일 발송하였습니다.
            <br />메일을 못 받으신 경우, 스팸함을 확인해주세요.
          </p>
          <p class="text-center">
            ※2시간 이내에 이메일 인증을 완료하지 못한 경우,
            <br />회원가입 절차를 처음부터 다시 진행해야 합니다.
          </p>
          <vs-button
            color="primary"
            @click.prevent="popupMailingComp = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 인증메일 발송완료//E -->
      </li>
      <li>
        <vs-button @click="popupLoginRefuse=true" color="primary" vs-type="filled">회원가입 불가 안내</vs-button>
        <!-- POPUP 회원가입 불가 안내//S -->
        <vs-popup title="로그인 안내" :active.sync="popupLoginRefuse">
          <p class="text-center">
            입력하신 이메일(계정)은
            <br />이미 회원으로 가입된 정보입니다.
          </p>
          <p class="text-center">로그인을 진행 하시겠습니까?</p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                color="#717171"
                @click.prevent="popupLoginRefuse = false"
                class="btn-gray btn-block"
              >다음에 하기</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                color="primary"
                onclick="window.location.href='/login'"
                class="btn-block custom"
                type="filled"
              >확인</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 회원가입 불가 안내//E -->
      </li>
      <li>
        <vs-button @click="popupMinorRefuse=true" color="primary" vs-type="filled">서비스 이용제한 안내</vs-button>
        <!-- POPUP 서비스 이용제한 안내//S -->
        <vs-popup title="서비스 이용제한 안내" :active.sync="popupMinorRefuse">
          <p class="text-center">
            죄송합니다. 미성년자(만 19세 미만) 또는
            <br />외국인(국내 비거주자)은 본인인증을 진행할 수 없습니다.
          </p>
          <vs-button
            color="primary"
            @click.prevent="popupMinorRefuse = false"
            class="btn-block custom"
            type="filled"
          >확인</vs-button>
        </vs-popup>
        <!-- POPUP 서비스 이용제한 안내//E -->
      </li>
      <li>
        <!-- 필수 인증 안내//S-->
        <vs-button @click="popupRequireAuth=true" color="primary" vs-type="filled">필수인증 안내.</vs-button>
        <vs-popup title="필수인증 안내" :active.sync="popupRequireAuth">
          <p class="text-center">
            먼저 [미완료 인증 절차 : 예, 본인인증]을
            <br />완료하세요.
          </p>

          <vs-button
            color="primary"
            @click.prevent="popupRequireAuth = false"
            class="btn-block custom"
            type="filled"
          >확인</vs-button>
        </vs-popup>
        <!-- 필수 인증 안내//E -->
      </li>
      <li>
        <!-- OTP 앱 설정완료//S-->
        <vs-button @click="popupOtpSet=true" color="primary" vs-type="filled">OTP 앱 설정완료</vs-button>
        <vs-popup title="OTP 앱 설정완료" :active.sync="popupOtpSet">
          <p class="text-center">
            OTP 앱 설정 완료 되었습니다.
            <br />추후 복구를 위해서는 복구 코드가 필요합니다.
          </p>
          <div class="input-group">
            <vs-input
              type="text"
              pattern="[0-9]*"
              inputmode="decimal"
              label="OTP"
              placeholder="OTP Code"
              class="input-custom"
            ></vs-input>
            <span class="input-group-btn">
              <vs-button color="#b5b5b5" vs-size="small" class="btn-wide" type="filled">복사</vs-button>
            </span>
          </div>
          <vs-button
            color="primary"
            @click.prevent="popupOtpSet = false"
            class="btn-block custom"
            type="filled"
          >확인</vs-button>
        </vs-popup>
        <!-- OTP 앱 설정완료//E -->
      </li>
      <li>
        <!-- OTP 인증 해지//S-->
        <vs-button @click="popupOtpClose=true" color="primary" type="filled">OTP 인증 해지</vs-button>
        <vs-popup title="OTP 인증 해지" :active.sync="popupOtpClose">
          <p class="text-center">해지 후 출금 한도가 하향됩니다.</p>
          <div class="otp-input">
            <vs-input
              type="text"
              pattern="[0-9]*"
              inputmode="decimal"
              icon="security"
              label="OTP 인증번호"
              placeholder="OTP 코드 6자리"
              v-model="otpCode"
            ></vs-input>
          </div>
          <p class="text-center">입출금 OTP인증 서비스를 해지 하시겠습니까?</p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                color="#717171"
                @click.prevent="popupOtpClose = false"
                class="btn-gray btn-block"
              >취소</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button color="primary" class="btn-block custom" type="filled">확인</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- OTP 인증 해지//E -->
      </li>
      <li>
        <vs-button @click="popupNotice=true" color="primary" type="filled">암호화폐 거래의 위험고지</vs-button>
        <!-- POPUP 암호화폐 거래의 위험고지//S -->
        <vs-popup fullscreen title="암호화폐 거래의 위험고지" :active.sync="popupNotice">
          <p class="text-center">
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
          </p>
          <p class="text-left">
            <vs-checkbox v-model="notToday">위 내용을 충분히 숙지 하였습니다.</vs-checkbox>
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button color="#717171" class="btn-gray btn-block">오늘 하루 보지않기</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                color="primary"
                @click.prevent="popupNotice = false"
                class="btn-block custom"
                vs-type="filled"
              >{{$t('confirm.ok')}}</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 암호화폐 거래의 위험고지//E -->
      </li>
      <li>
        <!-- 로그인 안내 팝업//S -->
        <vs-button @click="popupGoLogin=true" vs-color="primary" vs-type="filled">로그인 하세요.</vs-button>
        <vs-popup title="로그인 하세요." :active.sync="popupGoLogin">
          <p class="text-center">
            FLYBIT의 다양한 서비스를
            <br />이용 하실 수 있습니다.
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupGoLogin = false"
                class="btn-gray btn-block"
              >서비스 둘러보기</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="primary"
                onclick="window.location.href='/login'"
                class="btn-block custom"
                vs-type="filled"
              >로그인</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- 로그인 안내 팝업//E -->
      </li>

      <li>
        <!-- 필수 인증 진행 안내//S-->
        <vs-button @click="popupMustAuth=true" vs-color="primary" vs-type="filled">필수인증 진행 안내.</vs-button>
        <vs-popup title="필수인증 절차를 완료하세요." :active.sync="popupMustAuth">
          <p class="text-center">
            본인 인증 후
            <br />이용할 수 있는 서비스 입니다.
          </p>
          <p class="text-center">인증센터로 이동 하시겠습니까?</p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupMustAuth = false"
                class="btn-gray btn-block"
              >다음에 하기</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="primary"
                onclick="window.location.href='/'"
                class="btn-block custom"
                vs-type="filled"
              >인증 진행</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- 필수 인증 진행 안내//E -->
      </li>

      <li>
        <!-- 주문확인//S-->
        <vs-button @click="popupTransactionConfirm=true" vs-color="primary" vs-type="filled">주문확인</vs-button>
        <vs-popup title="주문확인" :active.sync="popupTransactionConfirm">
          <p class="text-center">
            [주문수량]개의 [화폐명]을
            <br />[거래구분:구매, 판매] 합니다.
          </p>
          <p class="text-center">주문 하시겠습니까?</p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupTransactionConfirm = false"
                class="btn-gray btn-block"
              >취소</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button vs-color="primary" class="btn-block custom" vs-type="filled">주문하기</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- 주문확인/E -->
      </li>
      <li>
        <!-- POPUP 본인인증 진행 안내//S-->
        <vs-button @click="popupAuthGuide=true" vs-color="primary" vs-type="filled">본인인증 진행 안내</vs-button>
        <vs-popup title="본인인증 진행 안내" :active.sync="popupAuthGuide">
          <p class="text-center">
            본인인증을 완료하세요.
            <br />FLYBIT의 다양한 서비스를 이용 하실 수 있습니다.
          </p>
          <p class="text-center">
            ※필수인증절차(이메일 인증, 본인인증)를 완료해야만
            거래 및 입/출금 서비스를 이용하실 수 있습니다.
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupAuthGuide = false"
                class="btn-gray btn-block"
              >나중에 하기</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="primary"
                onclick="window.location.href='/'"
                class="btn-block custom"
                vs-type="filled"
              >인증 진행</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 본인인증 진행 안내//E -->
      </li>
      <li>
        <!-- POPUP 탈퇴 계정 안내//S-->
        <vs-button @click="popupRetired=true" vs-color="primary" vs-type="filled">탈퇴계정 안내</vs-button>
        <vs-popup title="탈퇴 계정 안내" :active.sync="popupRetired">
          <p class="text-center">
            입력하신 이메일(아이디)은
            <br />이미 탈퇴 처리 되었습니다.
          </p>
          <p class="text-center">
            자세한 내용이 궁금하시면
            <br />고객센터로 문의해 주시기 바랍니다.
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                onclick="window.location.href='/'"
                class="btn-gray btn-block"
              >메인화면</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="primary"
                onclick="window.location.href='/'"
                class="btn-block custom"
                vs-type="filled"
              >새 아이디로 가입</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 탈퇴 계정 안내//E -->
      </li>
      <li>
        <!-- POPUP 탈퇴신청 승인대기 안내//S-->
        <vs-button @click="popupWaitRetired=true" vs-color="primary" vs-type="filled">탈퇴신청 승인대기 안내</vs-button>
        <vs-popup title="탈퇴 계정 안내" :active.sync="popupWaitRetired">
          <p class="text-center">
            입력하신 이메일(아이디)은
            <br />탈퇴 처리를 위해 승인 대기 중 입니다.
          </p>
          <p class="text-center">
            자세한 내용이 궁금하시면
            <br />고객센터로 문의해 주시기 바랍니다.
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                onclick="window.location.href='/'"
                class="btn-gray btn-block"
              >메인화면</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="primary"
                onclick="window.location.href='/'"
                class="btn-block custom"
                vs-type="filled"
              >새 아이디로 가입</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 탈퇴신청 승인대기 안내//E -->
      </li>
      <li>
        <!-- POPUP 휴면 계정 안내//S-->
        <vs-button @click="popupSleepAccount=true" vs-color="primary" vs-type="filled">휴면 계정 안내</vs-button>
        <vs-popup title="휴면 계정 안내" :active.sync="popupSleepAccount">
          <p class="text-center">
            입력하신 이메일(아이디)은
            <br />장기간 서비스 미접속으로 휴면(잠금)
            <br />처리 되었습니다.
          </p>
          <p class="text-center">
            휴면(잠금) 해제를 원하시면 등록된
            <br />이메일(아이디)을 통해 인증을 완료해 주세요.
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupSleepAccount = false"
                class="btn-gray btn-block"
              >다음에 하기</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button vs-color="primary" class="btn-block custom" vs-type="filled">이메일 인증하기</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 휴면 계정 안내//E -->
      </li>
      <li>
        <!-- POPUP 비밀번호 오류 안내//S -->
        <vs-button @click="popupPwErr=true" vs-color="primary" vs-type="filled">PW 입력오류 안내</vs-button>
        <vs-popup title="비밀번호 오류 안내" :active.sync="popupPwErr">
          <p class="text-center">
            <span class="icon err"></span>
            <br />[입력오류: 1회]
          </p>
          <p class="text-center">비밀번호를 확인 후 다시 입력해 주세요.</p>
          <p class="text-center">
            ※5회 이상 입력오류 시 회원님의 계정이
            <br />잠김 처리되어 FLYBIT 로그인이 제한됩니다.
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupPwErr = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 비밀번호 오류 안내//E -->
      </li>
      <li>
        <!-- POPUP 인증실패 안내//S -->
        <vs-button @click="popupAuthErr=true" vs-color="primary" vs-type="filled">2차 인증실패 안내</vs-button>
        <vs-popup title="인증실패 안내" :active.sync="popupAuthErr">
          <p class="text-center">
            <span class="icon err"></span>
            <br />[인증실패: 1회]
          </p>
          <p class="text-center">인증번호를 확인 후 다시 입력해 주세요.</p>
          <p class="text-center">
            ※10회 이상 인증실패 시 회원님의 계정이
            <br />잠김 처리되어 FLYBIT 로그인이 제한됩니다.
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupAuthErr = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 인증실패 안내//E -->
      </li>
      <li>
        <!-- POPUP 로그인 제한 안내//S -->
        <vs-button @click="popupLoginErr=true" vs-color="primary" vs-type="filled">로그인 제한 안내</vs-button>
        <vs-popup title="로그인 제한 안내" :active.sync="popupLoginErr">
          <p class="text-center">
            <span class="icon err"></span>
            <br />연속된 입력 오류로 인해
            <br />회원님 계정의 로그인이 제한 되었습니다.
          </p>
          <p class="text-center">
            이메일 인증을 통한 비밀번호 재설정 후
            <br />다시 이용해 주세요.
          </p>
          <p class="text-center">
            ※ SMS/OTP 인증 실패로 인해 로그인 제한이
            <br />반복 발생 시 본인인증 및 OTP 등록의
            <br />재인증을 권장합니다.
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupLoginErr = false"
                class="btn-gray btn-block"
              >취소</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button vs-color="primary" class="btn-block custom" vs-type="filled">비밀번호 재설정</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 로그인 제한 안내//E -->
      </li>
      <li>
        <!-- POPUP 비밀번호 재설정 안내//S -->
        <vs-button @click="popupPwReset=true" vs-color="primary" vs-type="filled">비밀번호 재설정 안내</vs-button>
        <vs-popup title="비밀번호 재설정" :active.sync="popupPwReset">
          <p class="text-center">
            안전한 비밀번호의 관리와 개인정보 보호를 위해
            <br />180일(약 6개월)마다 비밀번호를 변경하기를 권장합니다.
          </p>
          <p class="text-center">비밀번호 재설정 후 안전하게 로그인하세요.</p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupPwReset = false"
                class="btn-gray btn-block"
              >취소</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button vs-color="primary" class="btn-block custom" vs-type="filled">비밀번호 재설정</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 비밀번호 재설정 안내//E -->
      </li>
      <li>
        <!-- POPUP 로그인 연장 안내//S -->
        <vs-button
          @click="popupLogoutTimer=true"
          vs-color="primary"
          vs-type="filled"
        >{{$t('notice.title.logoutInformation')}}</vs-button>
        <vs-popup :title="$t('notice.title.logoutInformation')" :active.sync="popupLogoutTimer">
          <p class="text-center">
            {{$t('notice.content.loginEffectiveTimeExpired')}}
            <br />
            {{$t('notice.content.extendLoginTimeContinue')}}
            <br />
          </p>
          <p class="text-center">
            <span class="txt-red">02분 42초</span> 이후 자동 로그아웃 됩니다.
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupLogoutTimer = false"
                class="btn-gray btn-block"
              >취소</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button vs-color="primary" class="btn-block custom" vs-type="filled">로그인 연장</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 로그인 연장 안내//E -->
      </li>
      <li>
        <!-- POPUP 강제 로그아웃 안내//S -->
        <!-- <vs-button
          @click="popupForceLogout=true"
          vs-color="primary"
          vs-type="filled"
        >{{$t('notice.title.logoutInformation')}}</vs-button>
        <vs-popup :title="$t('notice.title.logoutInformation')" :active.sync="popupForceLogout">
          <p class="text-center">
            {{$t('notice.content.AutomaticallyLoggedOut')}}
            <br />
          </p>
          <p class="text-center">
            {{$t('notice.content.pleaseLoginAgain')}}
            <br />
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                onclick="window.location.href='/login'"
                class="btn-gray btn-block"
              >취소</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="primary"
                onclick="window.location.href='/login'"
                class="btn-block custom"
                vs-type="filled"
              >로그인</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup> -->
        <!-- POPUP 강제 로그아웃 안내//E -->
      </li>
      <li>
        <!-- POPUP 출금 불가 안내//S -->
        <vs-button @click="popupUnableWithDraw=true" vs-color="primary" vs-type="filled">출금불가 안내</vs-button>
        <vs-popup title="출금불가 안내" :active.sync="popupUnableWithDraw">
          <p class="text-center">
            <span class="icon err"></span>
            <br />출금이 제한된 사용자 입니다.
          </p>
          <p class="text-center">
            자세한 내용은 고객센터로 문의해
            <br />주시기 바랍니다.
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupUnableWithDraw = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 출금 불가 안내//E -->
      </li>
      <li>
        <!-- POPUP 입금실패//S -->
        <vs-button @click="popupDepositErr=true" vs-color="primary" vs-type="filled">입금 실패</vs-button>
        <vs-popup title="입금실패" :active.sync="popupDepositErr">
          <p class="text-center">입금 실패 메시지:보난자 제공</p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupDepositErr = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 입금실패//E -->
      </li>
      <li>
        <!-- POPUP 입금확인//S -->
        <vs-button @click="popupDepositConfirm=true" vs-color="primary" vs-type="filled">입금 확인</vs-button>
        <vs-popup title="입금확인" :active.sync="popupDepositConfirm">
          <p class="text-center">
            유진투자증권 계좌 123-123456-12-123에서
            <br />10,000원을 FLYBIT KRW로
            <br />입금 신청 하시겠습니까?
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupDepositConfirm = false"
                class="btn-gray btn-block"
              >취소</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="primary"
                onclick="alert('확인')"
                class="btn-block custom"
                vs-type="filled"
              >{{$t('confirm.ok')}}</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 입금확인//E -->
      </li>
      <li>
        <!-- POPUP 입금 신청 완료//S -->
        <vs-button @click="popupDepositComplete=true" vs-color="primary" vs-type="filled">입금 신청 완료</vs-button>
        <vs-popup title="입금 신청 완료" :active.sync="popupDepositComplete">
          <p class="text-center">10,000 KRW를 입금 신청 완료 되었습니다.</p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                onclick="window.location.href='/withdrawlist'"
                class="btn-gray btn-block"
              >KRW 입출금 내역</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="primary"
                @click.prevent="popupDepositComplete = false"
                class="btn-block custom"
                vs-type="filled"
              >{{$t('confirm.ok')}}</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 입금 신청 완료//E -->
      </li>
      <li>
        <vs-button @click="popupDepositCheck=true" vs-color="primary" vs-type="filled">입금주소 확인</vs-button>
        <!-- POPUP 입금주소 확인//S -->
        <vs-popup fullscreen title="입금주소 확인" :active.sync="popupDepositCheck">
          <p class="text-left">암호화폐 입금주소를 반드시 확인하고 송금하세요.</p>
          <p class="text-left">입금주소를 잘못 입력하실 경우 송금이 정상적으로 이루어지지 않아 회원님의 자산을 찾지 못할 수 있습니다.</p>
          <p class="text-left">
            잘못된 암호화폐 송금에 대한 복구 작업은 본질적으로 큰 위험이
            따르고 오랜 시간을 소요하기 때문에 해당 문제가 발생될 경우 FLYBIT는 어떠한 지원도 해드릴 수 없습니다.
          </p>
          <p class="text-left">
            <vs-checkbox v-model="notToday">위 내용을 충분히 숙지 하였습니다.</vs-checkbox>
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupDepositCheck = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 입금주소 확인//E -->
      </li>
      <li>
        <vs-button @click="popupWithdrawComplete=true" vs-color="primary" vs-type="filled">출금 신청 완료</vs-button>
        <!-- POPUP 입금주소 확인//S -->
        <vs-popup title="출금 신청 완료" :active.sync="popupWithdrawComplete">
          <p class="text-center">
            신청된 출금 처리는 순차적으로 진행되며,
            <br />네트워크의 환경에 따라 일정 시간이
            <br />소요될 수 있습니다.
          </p>

          <p class="text-center">
            출금수량
            <span class="txt-blue">
              <strong>12,345.67890123</strong> ETC
            </span>
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupWithdrawComplete = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 입금주소 확인//E -->
      </li>
      <li>
        <vs-button @click="popupPrivacyPolicy=true" vs-color="primary" vs-type="filled">개인정보 수집/이용방침</vs-button>
        <!-- POPUP 이용약관//S -->
        <vs-popup fullscreen title="개인정보 수집/이용방침" :active.sync="popupPrivacyPolicy">
          <p class="clearfix">
            <vs-select class="pull-right" label="개정일" v-model="select1">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in date"
              />
            </vs-select>
          </p>
          <p class="text-center">
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
          </p>

          <vs-button
            vs-color="primary"
            @click.prevent="popupPrivacyPolicy = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 이용약관//E -->
      </li>
      <li>
        <vs-button @click="popupTerms=true" vs-color="primary" vs-type="filled">이용약관</vs-button>
        <!-- POPUP 이용약관//S -->
        <vs-popup fullscreen title="이용약관" :active.sync="popupTerms">
          <p class="clearfix">
            <vs-select class="pull-right" label="개정일" v-model="select1">
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item,index) in date"
              />
            </vs-select>
          </p>
          <p class="text-center">
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
          </p>

          <vs-button
            vs-color="primary"
            @click.prevent="popupTerms = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 이용약관//E -->
      </li>
      <li>
        <!-- POPUP 모바일 미지원 안내//S -->
        <vs-button @click="popupMobileUnsupport=true" vs-color="primary" vs-type="filled">모바일 미지원 안내</vs-button>
        <vs-popup :title="$t('unableMobile.title')" :active.sync="popupMobileUnsupport">
          <p class="text-center">
            해당 서비스는 모바일로 지원 되지 않습니다.
            <br />추후 오픈 될 예정입니다.
          </p>
          <p class="text-center">이용에 불편을 드려 죄송합니다.</p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupMobileUnsupport = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 모바일 미지원 안내//E -->
      </li>
      <li>
        <!-- POPUP 계좌등록 안내//S 완 -->
        <vs-button @click="popupAccountGuide=true" vs-color="primary" vs-type="filled">계좌 등록 안내</vs-button>
        <vs-popup title="계좌 등록 안내" :active.sync="popupAccountGuide">
          <div class="well well-black">
            FLYBIT에서는 유진투자증권 계좌만 인증 할 수 있습니다.
            <br />유진투자증권 계좌가 없으신 분은 계좌를 개설 하여 주시기 바랍니다.
          </div>
          <h3>유진투자증권 개좌 개설 방법</h3>
          <h4>1.홈페이지 안내보기</h4>
          <p>
            <vs-button
              vs-color="#b5b5b5"
              vs-size="small"
              onclick="window.location.href='https://www.eugenefn.com/serv/svoa/svoa499r.do'"
            >바로가기</vs-button>
          </p>
          <h4>2.계좌개설 APP 다운로드 SMS 전송 받기</h4>
          <vs-button vs-color="#b5b5b5" vs-size="small">설치SMS 전송</vs-button>
          <h4>3.개설 후 FLYBIT에 계좌 등록 하기</h4>
          <hr class="transpaernt" />
          <p>※ 계좌 개설 문의 : 유진투자증권 고객센터 1588-6300</p>

          <vs-button
            vs-color="primary"
            @click.prevent="popupAccountGuide = false, popupAccountAgree = true"
            class="btn-block custom"
            vs-type="filled"
          >계좌등록</vs-button>
        </vs-popup>
        <!-- POPUP 계좌등록 안내//E -->
      </li>
      <li>
        <!-- POPUP 약관동의//S -->
        <vs-button @click="popupAccountAgree=true" vs-color="primary" vs-type="filled">약관동의</vs-button>
        <vs-popup title="이용약관" :active.sync="popupAccountAgree">
          <p class="text-left">
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
            상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT) 상세내용(TEXT)
          </p>
          <div class="account-regist-check clearfix">
            <vs-checkbox v-model="notToday">위 내용을 확인하고, 동의합니다.</vs-checkbox>
          </div>
          <vs-button
            vs-color="primary"
            @click.prevent="popupAccountAgree = false, popupAccountRegist = true"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 약관동의//E -->
      </li>
      <li>
        <!-- POPUP 계좌 등록//S -->
        <vs-button @click="popupAccountRegist=true" vs-color="primary" vs-type="filled">계좌 등록</vs-button>
        <vs-popup title="계좌 등록" :active.sync="popupAccountRegist">
          <h3>계좌 정보입력</h3>
          <vs-input
            label="예금주"
            placeholder="홍길동"
            class="input-block input-custom disable-custom"
            v-model="username"
            disabled="true"
          ></vs-input>
          <vs-input
            label="은행"
            placeholder="유진투자증권"
            class="input-block input-custom disable-custom"
            v-model="bankname"
            disabled="true"
          ></vs-input>
          <vs-input
            type="text"
            pattern="[0-9]*"
            inputmode="decimal"
            label="계좌번호"
            placeholder="하이픈 '-' 없이 숫자만 입력"
            class="input-block input-custom"
            v-model="banknumber"
          ></vs-input>

          <div class="well well-black">
            <ul class="number-list">
              <li>실명확인 계좌는 본인명의의 유진투자증권 계좌 1개만 등록 가능합니다.</li>
              <li>KRW의 입금과 출금은 인증 및 등록 완료한 실명확인 계좌를 통해서만 가능 합니다.</li>
              <li>FLYBIT에 본인인증 된 실명과 계좌 예금주 명의가 일치해야 합니다.</li>
              <li>은행 점검 시간에는 해당 계좌에 대한 인증이 지연 또는 불가능할 수 있습니다.</li>
            </ul>
          </div>
          <vs-button
            vs-color="primary"
            @click.prevent="popupAccountRegist = false, popupAccountCertify = true"
            class="btn-block custom"
            vs-type="filled"
          >다음</vs-button>
        </vs-popup>
        <!-- POPUP 계좌 등록//E -->
      </li>
      <li>
        <!-- POPUP 계좌 인증//S -->
        <vs-button @click="popupAccountCertify=true" vs-color="primary" vs-type="filled">계좌인증</vs-button>
        <vs-popup title="계좌인증" :active.sync="popupAccountCertify">
          <h3>계좌 정보입력</h3>
          <div class="input-group">
            <vs-input
              label="계좌정보"
              placeholder="계좌정보"
              class="input-custom disable-custom"
              v-model="bankinfo"
              disabled="true"
            ></vs-input>
            <span class="input-group-btn">
              <vs-button color="#b5b5b5" size="small" class="btn-wide" vs-type="filled">계좌인증요청</vs-button>
            </span>
          </div>
          <vs-input
            type="text"
            pattern="[0-9]*"
            inputmode="decimal"
            label="입금자명"
            placeholder="숫자3자리입력"
            class="input-block input-custom"
          ></vs-input>
          <div class="well well-black">
            <ul class="number-list">
              <li>계좌인증 버튼을 클릭 후 등록하신 계좌로 1원을 송금해 드립니다.</li>
              <li>입금자명 플라이빗 제외한 숫자 3자리만 입력하여 주세요.</li>
              <li>5회 이상 계좌 인증 실패 시 24시간 이후에 재시도 가능합니다.</li>
              <li>10분 이내 미 입력 시 계좌 인증 실패 1회로 인정됩니다.</li>
            </ul>
          </div>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupAccountRegist = false"
                class="btn-gray btn-block"
              >취소</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
              <vs-button
                vs-color="primary"
                onclick="alert('인증')"
                class="btn-block custom"
                vs-type="filled"
              >계좌 인증 및 등록</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 계좌 인증//E -->
      </li>
      <li>
        <!-- POPUP 계좌 등록실패//S -->
        <vs-button @click="popupAccountAuthFail=true" vs-color="primary" vs-type="filled">계좌 등록 실패</vs-button>
        <vs-popup title="계좌 등록 실패 안내" :active.sync="popupAccountAuthFail">
          <p class="text-center">
            <span class="icon err"></span>
            <br />
            <strong>
              FLYBIT에 등록할 수 없는 계좌 입니다.
              <br />예금주와 계좌번호를 한번더 확인 부탁드립니다.
            </strong>
          </p>
          <p class="text-center">
            본인 인증과 동일한 예금주의
            <br />유진투자증권계좌만 등록 가능합니다.
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupAccountAuthFail = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 계좌 등록실패//E -->
      </li>
      <li>
        <!-- POPUP 계좌 등록실패 (5회)//S -->
        <vs-button
          @click="popupAccountAuthFail5=true"
          vs-color="primary"
          vs-type="filled"
        >계좌 등록 실패 5회</vs-button>
        <vs-popup title="계좌 등록 실패 안내" :active.sync="popupAccountAuthFail5">
          <p class="text-center">
            <span class="icon err"></span>
            <br />
            <strong>
              계좌인증 5회 이상 실패하여
              <br />
              <span class="txt-blue">24시간 후에 재 인증 가능</span> 합니다.
            </strong>
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupAccountAuthFail5 = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>

        <!-- POPUP 계좌 등록실패 (5회)//E -->
      </li>
      <li>
        <!-- POPUP 계좌 등록실패 (입금자명 불일치)//S -->
        <vs-button
          @click="popupAccountAuthFailNotMatch=true"
          vs-color="primary"
          vs-type="filled"
        >계좌 등록 실패 입금자명 불일치</vs-button>
        <vs-popup title="계좌 등록 실패 안내" :active.sync="popupAccountAuthFailNotMatch">
          <p class="text-center">
            <span class="icon err"></span>
            <br />
            <strong>입금자명 숫자가 일치하지 않습니다.</strong>
          </p>
          <p class="text-center">
            5회 이상 계좌 인증 실패 시
            <br />24시간 이후에 재시도 가능합니다.
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupAccountAuthFailNotMatch = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 계좌 등록실패 (입금자명 불일치)//E -->
      </li>
      <li>
        <!-- POPUP 계좌 인증완료//S -->
        <vs-button @click="popupAccountSuccess=true" vs-color="primary" vs-type="filled">계좌 인증완료</vs-button>
        <vs-popup title="계좌 인증 완료" :active.sync="popupAccountSuccess">
          <p class="text-center">
            <span class="icon success"></span>
            <br />
            <strong>계좌 인증 및 등록이 완료 되었습니다.</strong>
          </p>
          <p class="text-center">(유진투자증권 123-456-789)</p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupAccountSuccess = false"
                class="btn-gray btn-block"
              >확인</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="primary"
                onclick="alert('입금 실행')"
                class="btn-block custom"
                vs-type="filled"
              >KRW 입금하기</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 계좌 인증완료//E -->
      </li>
      <li>
        <!-- POPUP 계좌 인증해지//S -->
        <vs-button @click="popupRemoveAccount=true" vs-color="primary" vs-type="filled">인증해지</vs-button>
        <vs-popup title="계좌인증 해지" :active.sync="popupRemoveAccount">
          <p class="text-center">
            <strong>입출금 계좌 인증을 해지 하시겠습니까?</strong>
            <br />(유진투자증권 123-456-789)
          </p>
          <p class="text-center">
            FLYBIT의 입/출금 거래를 위해선
            <br />계좌 인증이 필수 입니다.
            <br />인증 등급이 레벨 2가 되어 출금 한도가 하향됩니다.
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupRemoveAccount = false"
                class="btn-gray btn-block"
              >취소</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="primary"
                onclick="alert('확인')"
                class="btn-block custom"
                vs-type="filled"
              >{{$t('confirm.ok')}}</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 계좌 인증해지//E -->
      </li>
      <li>
        <!-- POPUP 계좌 인증해지 완료//S -->
        <vs-button @click="popupRemoveAccountTrue=true" vs-color="primary" vs-type="filled">인증해지 완료</vs-button>
        <vs-popup title="계좌 해제 완료" :active.sync="popupRemoveAccountTrue">
          <p class="text-center">
            <span class="icon success"></span>
            <br />
            <strong>
              입출금 계좌 인증 해제가
              <br />완료 되었습니다.
            </strong>
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupRemoveAccountTrue = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 계좌 인증해지 완료//E -->
      </li>
      <li>
        <!-- POPUP 계좌 인증해지 실패//S -->
        <vs-button @click="popupRemoveAccountFalse=true" vs-color="primary" vs-type="filled">인증해지 실패</vs-button>
        <vs-popup title="계좌 해제 실패" :active.sync="popupRemoveAccountFalse">
          <p class="text-center">
            <span class="icon err"></span>
            <br />
            <strong>
              입출금 계좌 인증 해제가
              <br />실패하였습니다.
            </strong>
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupRemoveAccountFalse = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 계좌 인증해지 실패//E -->
      </li>
      <li>
        <vs-button @click="popupDepositAddress=true" vs-color="primary" vs-type="filled">입금주소록</vs-button>

        <vs-popup title="입금 주소록" fullscreen :active.sync="popupDepositAddress">
          <!-- 등록//S -->
          <div class="panel panel-dark deposit-address">
            <div class="panel-heading" v-on:click="active = !active" :class="{active: active}">
              입금주소 등록
              <span class="icon-arrow"></span>
            </div>
            <transition name="fade">
              <div class="panel-body" v-if="active">
                <div class="input-master input-block vs-con-input input-custom vs-con-input-label">
                  <input type="text" placeholder="주소이름을 입력하세요." class="form-control" />
                </div>
                <div class="input-master input-block vs-con-input input-custom vs-con-input-label">
                  <input type="text" placeholder="입금주소를 입력하세요." class="form-control" />
                </div>
                <vs-row>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
                    <vs-button
                      vs-color="#717171"
                      @click.prevent="popupDepositAddress = false"
                      class="btn-gray btn-block"
                    >{{$t('confirm.cancel')}}</vs-button>
                  </vs-col>
                  <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
                    <vs-button
                      vs-color="#f01b5c"
                      onclick="alert('인증')"
                      class="btn-block custom"
                      vs-type="filled"
                    >등록</vs-button>
                  </vs-col>
                </vs-row>
              </div>
            </transition>
          </div>
          <!-- 등록//E -->
          <!-- 주소록//S -->
          <div class="deposit-address-list">
            <ul>
              <li
                v-for="(addressinfo, index) in addressList"
                :key="index"
                :class="{active:addressinfo.coincode == pickWallet}"
                @click="pickWallet = addressinfo.coincode"
              >
                <div class="panel panel-gray">
                  <div class="panel-heading">
                    <h4 class="clearfix">
                      {{addressinfo.coinname}} ({{addressinfo.coincode}})
                      <small
                        class="pull-right"
                      >{{addressinfo.market}}</small>
                    </h4>
                  </div>
                  <div class="panel-body">
                    <div class="address-wrap">
                      <p>입금주소</p>
                      <span>{{addressinfo.address}}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <!-- 주소록//E -->
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
              <vs-button
                vs-color="#717171"
                @click.prevent="popupDepositAddress = false"
                class="btn-gray btn-block"
              >취소</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="9">
              <vs-button
                vs-color="primary"
                onclick="alert('인증')"
                class="btn-block custom"
                vs-type="filled"
              >선택완료</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
      </li>
      <li>
        <!-- //S -->
        <vs-button @click="popupSuspicion=true" vs-color="primary" vs-type="filled">의심거래 접속차단</vs-button>
        <vs-popup title="접속차단" :active.sync="popupSuspicion">
          <p class="text-center">
            <strong>
              이상 또는 의심거래 사용자로
              <br />등록되어 접속을 차단합니다.
            </strong>
          </p>
          <p class="text-center">고객센터로 문의 바랍니다.</p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupSuspicion = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- //E -->
      </li>
      <li>
        <!-- //S -->
        <vs-button @click="popupBlackList=true" vs-color="primary" vs-type="filled">블랙리스트 출금차단</vs-button>
        <vs-popup title="출금차단" :active.sync="popupBlackList">
          <p class="text-center">
            <strong>
              이상 또는 의심거래로 탐지되어 출금을 차단합니다.
              <br />고객센터로 문의 바랍니다.
            </strong>
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupBlackList = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- //E -->
      </li>
      <li>
        <vs-button @click="noticeModal=true" vs-color="primary" vs-type="filled">가상화폐 거래의 위험고지</vs-button>
        <!-- POPUP 가상화폐 거래의 위험고지//S -->
        <vs-popup fullscreen title="가상화폐 거래의 위험고지" :active.sync="noticeModal">
          <div>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >가상화폐 거래에는 다양한 위험이 존재합니다.</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >플라이빗 거래 서비스에 참여하는 회원께서는 아래 내용을 충분히 숙지하시고</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >동의 과정을 거쳐 거래에 참여하실 수 있습니다.&nbsp;&nbsp;</p>
            <p style="text-align: justify; line-height: 1.2;" align="justify">&nbsp;</p>
            <p style="text-align: justify; line-height: 1.2;" align="justify">▶ 가격 변동의 위험</p>
            <p style="text-align: justify; line-height: 1.2;" align="justify">&nbsp;</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >가상화폐 가격의 변동성은 상당히 높습니다.&nbsp;</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >회원의 가상 통화 거래·보유 시 가상화폐 가격이 급격히 변동, 하락 가능성이 있습니다.&nbsp;</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >수급 균형의 변화와 다른 시장의 동향, 천재지변, 전쟁, 법적 및 규제 변화, 가상화폐에 관한 상황의 변화 등 예기치 못한 사건이나 특수 사건에 따라 급격하게 가격 변동이 발생할 수 있습니다.</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >가상화폐 구입 시 투자의 손익과 손실은 전적으로 투자자의 판단입니다.</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >이로 인해 발생되는 예상치 못한 손실에 대해 당사는 일체의 책임을 지지 않습니다.</p>
            <p style="text-align: justify; line-height: 1.2;" align="justify">&nbsp;</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >▶ 법령 및 금융 당국의 규제에 따른 변경으로 발생 될 위험</p>
            <p style="text-align: justify; line-height: 1.2;" align="justify">&nbsp;</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >회사는 거래와 관련된 정책 중 수수료, 비용, 입출금 금액 한도 등에 대해 법령 또는 금융 당국의 규제에 따라 변경 할 수 있습니다.</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >이는 현재보다 불리한 거래 환경으로 변경 될 수도 있음을 의미합니다.</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >이로 인해 발생되는 예상치 못한 손실에 대해 당사는 일체의 책임을 지지 않습니다.</p>
            <p style="text-align: justify; line-height: 1.2;" align="justify">&nbsp;</p>
            <p style="text-align: justify; line-height: 1.2;" align="justify">▶ 가상화폐 자체의 위험성</p>
            <p style="text-align: justify; line-height: 1.2;" align="justify">&nbsp;</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >회사가 취급하는 가상화폐 중에는 현 시점에서 기술·안정성 등이 검증되지 않은 가상화폐 들이 있을 수 있습니다.</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >이러한 가상화폐들은 기술적인 문제로 해킹 및 상장폐지 등의 위험성을 가지고 있으며, 투기적 세력들에 의해 시세가 급등락 될 수도 있습니다.&nbsp;</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >이로 인해 발생되는 예상치 못한 손실에 대해 당사는 일체의 책임을 지지 않습니다.</p>
            <p style="text-align: justify; line-height: 1.2;" align="justify">&nbsp;</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >위의 요소들이 거래에 생기는 모든 위험을 전부 보여주는 것은 아닙니다.&nbsp;</p>
            <p style="text-align: justify; line-height: 1.2;" align="justify">&nbsp;</p>
            <p
              style="text-align: justify; line-height: 1.2;"
              align="justify"
            >투자 시 각별히 주의하시기 바랍니다.​&nbsp;</p>
          </div>
          <p class="text-left">
            <vs-checkbox v-model="notToday">위 내용을 충분히 숙지 하였습니다.</vs-checkbox>
          </p>
          <vs-row>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button vs-color="#717171" class="btn-gray btn-block">오늘 하루 보지않기</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <vs-button
                vs-color="primary"
                @click.prevent="noticeModal = false"
                class="btn-block custom"
                vs-type="filled"
              >{{$t('confirm.ok')}}</vs-button>
            </vs-col>
          </vs-row>
        </vs-popup>
        <!-- POPUP 가상화폐 거래의 위험고지//E -->
      </li>
      <li>
        <vs-button @click="popupKrwCome=true" vs-color="primary" vs-type="filled">원화마켓오픈예정</vs-button>
        <!-- POPUP 원화마켓오픈예정//S -->
        <vs-popup title="원화마켓 오픈 예정" :active.sync="popupKrwCome">
          <p class="text-center">
            <span class="icon krw"></span>
            <br />
            <strong>
              11월 중
              <br />원화마켓 오픈 예정입니다.
            </strong>
          </p>
          <p class="text-center">빠른시일내에 오픈하도록 하겠습니다.</p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupKrwCome = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 원화마켓오픈예정//S -->
      </li>
      <!-- <li>
        <vs-input label="OTP" placeholder="OTP Code" class="input-custom"></vs-input>
        <div class="input-master input-custom vs-con-input-label">
          <label for="" class="vs-input-label">OTP</label>
          <input type="text" placeholder="OTP Code" class="form-control" >
        </div>
      </li>-->
      <li>
        <vs-button @click="popupOrderComp=true" vs-color="primary" vs-type="filled">주문완료</vs-button>
        <!-- POPUP 주문완료//S -->
        <vs-popup title="주문완료" :active.sync="popupOrderComp">
          <p class="text-center">
            0.12345678개의 비트코인을(를) 매수
            <br />
            <span class="txt-blue">주문 완료</span> 하였습니다.
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupOrderComp = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 주문완료//E -->
      </li>
      <li>
        <vs-button @click="popupDepositUnable=true" vs-color="primary" vs-type="filled">입금제한</vs-button>
        <!-- POPUP 입금제한//S -->
        <vs-popup title="입금제한" :active.sync="popupDepositUnable">
          <p class="text-center">
            은행전산시스템 점검으로 인하여
            <br />
            <span class="txt-blue">20:00~22:00 까지</span>
            <br />플라이빗에서 입금 서비스 이용이 제한됩니다.
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupDepositUnable = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 입금제한//E -->
      </li>
      <li>
        <vs-button @click="popupWithdrawUnable=true" vs-color="primary" vs-type="filled">출금제한</vs-button>
        <!-- POPUP 출금제한//S -->
        <vs-popup title="출금제한" :active.sync="popupWithdrawUnable">
          <p class="text-center">
            은행전산시스템 점검으로 인하여
            <br />
            <span class="txt-blue">20:00~22:00 까지</span>
            <br />플라이빗에서 출금 서비스 이용이 제한됩니다.
          </p>
          <vs-button
            vs-color="primary"
            @click.prevent="popupWithdrawUnable = false"
            class="btn-block custom"
            vs-type="filled"
          >{{$t('confirm.ok')}}</vs-button>
        </vs-popup>
        <!-- POPUP 출금제한//E -->
      </li>
    </ol>
  </div>
</template>
<script>
export default {
  data() {
    return {
      actives: 0,
      isActive: false,
      popupRestrict: false, // 서비스 이용제한 안내
      popupMailingComp: false, // 인증메일 발송완료
      popupLoginRefuse: false, // 회원가입 불가 안내
      popupMinorRefuse: false, // 서비스 이용제한 안내
      popupRequireAuth: false, // 필수인증 안내
      popupOtpSet: false, // OTP 앱 설정 완료
      popupOtpClose: false, // OTP 인증 해지
      popupNotice: false, // 암호화폐 거래의 위험고지
      popupGoLogin: false, // 로그인 하세요
      popupMustAuth: false, // 필수인증 진행 안내
      popupTransactionConfirm: false, //주문확인
      popupAuthGuide: false, // 본인인증 진행 안내
      popupRetired: false, // 탈퇴 계정 안내
      popupWaitRetired: false, // 탈퇴신청 승인대기 안내
      popupSleepAccount: false, //휴면 계정 안내
      popupPwErr: false, // PW 입력오류 안내
      popupAuthErr: false, // 2차 인증 실패 안내
      popupLoginErr: false, // 로그인 제한 안내
      popupPwReset: false, // 비밀번호 재설정 안내
      popupLogoutTimer: false, //로그인 연장 안내
      popupForceLogout: false, // 강제 로그아웃 안내
      popupUnableWithDraw: false, // 출금불가 안내
      popupDepositErr: false, // 입금 실패
      popupDepositConfirm: false, // 입금 확인
      popupDepositComplete: false, // 입금 신청 완료
      popupDepositCheck: false, // 입금주소 확인
      popupWithdrawComplete: false, // 출금신청 완료
      popupTerms: false, // 이용약관
      popupPrivacyPolicy: false, // 개인정보 수집/이용 방침
      popupMobileUnsupport: false, // 모바일 미지원 안내

      popupAccountGuide: false, // 계좌 등록 안내
      popupAccountAgree: false, // 약관동의
      popupAccountRegist: false, // 계좌 등록
      popupAccountCertify: false, // 계좌 인증
      popupAccountAuthFail: false, // 계좌 인증 실패
      popupAccountAuthFail5: false, // 계좌 인증 실패 5회
      popupAccountAuthFailNotMatch: false, // 계좌인증 실패 입금자명 불일치
      popupAccountSuccess: false, // 계좌인증 완료
      popupRemoveAccount: false, // 인증해지
      popupRemoveAccountTrue: false, // 인증해지 완료
      popupRemoveAccountFalse: false, // 인증해지 실패
      popupSuspicion: false, // 의심거래 접속차단
      popupBlackList: false, // 블랙리스트 접속차단
      noticeModal: false, // 가상화폐 거래의 위험 고지
      popupKrwCome: false, //KRW 오픈 예정
      popupOrderComp: false, // 주문완료
      popupDepositUnable: false, // 입금제한
      popupWithdrawUnable: false, // 출금제한

      username: "홍길동", // 예금주
      bankname: "유진투자증권", // 은행
      banknumber: "", // 계좌번호
      bankinfo: "",
      popupDepositAddress: false, // 입금 주소록
      otpCode: "",
      notToday: false,
      active: false,
      select1: 0,
      date: [{ text: "개정 2018.08.12", value: 0 }],
      pickWallet: undefined,
      addressList: [
        {
          coinname: "모네로",
          coincode: "XMR",
          market: "B-BOX",
          address:
            "4HmoXnbeopf9V2TnSNrhjCdB9WT95a4nseV86vZKtqPoSxP5gnWjdLaAGnsNy3dXvwaq78t4MSA5GGWs9DQCNoSxP5gnWjdLaAGnsNy3dXvwa",
        },
        {
          coinname: "비트코인",
          coincode: "BTC",
          market: "B-BOX",
          address:
            "4HmoXnbeopf9V2TnSNrhjCdB9WT95a4nseV86vZKtqPoSxP5gnWjdLaAGnsNy3dXvwaq78t4MSA5GGWs9DQCNoSxP5gnWjdLaAGnsNy3dXvwa",
        },
        {
          coinname: "이더리움클래식",
          coincode: "ETC",
          market: "B-BOX",
          address:
            "4HmoXnbeopf9V2TnSNrhjCdB9WT95a4nseV86vZKtqPoSxP5gnWjdLaAGnsNy3dXvwaq78t4MSA5GGWs9DQCNoSxP5gnWjdLaAGnsNy3dXvwa",
        },
        {
          coinname: "이더리움",
          coincode: "ETH",
          market: "B-BOX",
          address:
            "4HmoXnbeopf9V2TnSNrhjCdB9WT95a4nseV86vZKtqPoSxP5gnWjdLaAGnsNy3dXvwaq78t4MSA5GGWs9DQCNoSxP5gnWjdLaAGnsNy3dXvwa",
        },
      ],
    };
  },
};
</script>
<style>
</style>
